import type {TicketFiltersValue, TicketState, TicketType} from './types';

const TICKET_TYPES = new Set<TicketType>(['general', 'order', 'loan']);
const TICKET_STATES = new Set<TicketState>([
  'created',
  'done',
  'inprogress',
  'deleted',
  'rejected'
]);

const parseQueryValues = <T extends string>(value: string | null, allowedValues: Set<T>): T[] =>
  value
    ? value
        .split(',')
        .filter((item): item is T => allowedValues.has(item as T))
        .filter((item, index, values) => values.indexOf(item) === index)
    : [];

export const createTicketFiltersFromQuery = (query: {
  order_code: string | null;
  type: string | null;
  state: string | null;
}): TicketFiltersValue => ({
  order_code: query.order_code ?? '',
  types: parseQueryValues(query.type, TICKET_TYPES),
  states: parseQueryValues(query.state, TICKET_STATES)
});
